<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
          <div class="card-header p-primary bg-transparent">
            <h5 class="card-title d-inline-block mb-0">{{ $t("edit_job") }}</h5>
          </div>
          <!-- <app-overlay-loader v-if="preloader" /> -->
          <!-- <div class="row">
          <div class="col-sm-12">
            <div class="card-body">
              <el-steps :active="active">
                <el-step></el-step>
                <el-step></el-step>
                <el-step></el-step>
              </el-steps>
            </div>
          </div>
        </div> -->
          <!-- <el-form v-if="active === 1"> -->
          <div class="card-body">
            <form
              class="mb-0"
              ref="form"
              :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
            >
              <div class="form-group row">
                <div class="col-sm-6">
                  <label for="inputs_name" >
                    {{ $t("title") }}
                  </label>
                  <app-input
                    id="inputs_name"
                    
                    type="text"
                    v-model="job.title"
                    placeholder="Enter Job Title"
                    :required="true"
                  />
                </div>
                <div class="col-sm-6">
                  <label for="inputs_category" >
                    {{ $t("category") }}
                  </label>
                  <app-input
                    id="inputs_category"
                    type="search-select"
                    :placeholder="$t('select_category')"
                    :required="true"
                    v-model="job.category_id"
                    :list="category"
                  />
                  <p class="font-italic text-muted">
                    {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
                  </p>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <label for="inputs_email">
                    {{ $t("short_description") }}
                  </label>
                  <app-input
                    id="inputs_email"
                    type="textarea"
                    placeholder="Short Description About Job"
                    v-model="job.short_description"
                    :required="true"
                  />
                </div>
                
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label for="inputs_status">
                  {{ $t("start_date") }}
                  </label>
                  <app-input
                    id="inputs_status"
                    type="date"
                    :required="true"
                    v-model="job.start_date"
                  />
                </div>
                <div class="col-sm-6">
                  <label for="inputs_status">
                    {{ $t("end_date") }}
                  </label>
                  <app-input
                    id="inputs_status"
                    type="date"
                    :required="true"
                    v-model="job.end_date"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-4">
                  <label for="inputs_status">
                    {{ $t("bid_range") }}
                  </label>
                    <app-input
                      id="inputs_status"
                      type="text"
                      :required="true"
                      placeholder="Enter Bid Range Amont"
                      v-model="job.bid_range"
                    />
                </div>
                <div class="col-md-2 col-sm-2" style="margin-top: 2rem">
                  <app-input
                    id="inputs_range"
                    type="select"
                    :required="true"
                    v-model="job.range"
                    :list="bidRangeList"
                  />
                  <p class="font-italic text-muted">
                    <a href="#" @click.prevent="addDropdown(type='range' )">{{$t("add_bid_range")}}</a>
                  </p>
                </div>
                <div class="col-sm-6">
                  <label for="inputs_status">
                    {{ $t("job_type") }}
                  </label>
                  <app-input
                    id="inputs_status"
                    type="select"
                    :required="true"
                    v-model="job.job_type"
                    :list="jobTypeList"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label for="inputs_status">
                  {{ $t("job_status") }}
                  </label>
                  <app-input
                    id="inputs_status"
                    type="select"
                    :required="true"
                    v-model="job.status"
                    :list="status"
                  />
                </div>
                <div class="col-sm-6">
                  <label for="inputs_status">
                    {{ $t("is_private") }}
                  </label>
                  <app-input
                    id="inputs_status"
                    type="select"
                    :required="true"
                    v-model="job.is_private"
                    :list="is_private"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label for="region" >
                    {{ $t("region") }}
                  </label>
                  <app-input
                    id="region"
                    type="select"
                    v-model="job.region"
                    :list="regionlist"
                  />
                  <p class="font-italic text-muted">
                    {{ $t("shortcut_add_dropdown") }} <span><a href="#" @click.prevent="addDropdown(type='region' )">{{$t("add_region")}}</a></span>
                  </p>
                </div>
                <div class="col-sm-6">
                  <label for="noticetype">
                    {{ $t("notice_type") }}
                  </label>
                  <app-input
                    id="noticetype"
                    type="select"
                    v-model="job.noticetype"
                    :list="noticetypelist"
                  />
                  <p class="font-italic text-muted">
                    {{ $t("shortcut_add_dropdown") }} <span><a href="#" @click.prevent="addDropdown(type='notice' )">{{$t("add_notice_type")}}</a></span>
                  </p>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label for="threshold">
                    {{ $t("threshold") }}
                  </label>
                  <app-input
                    id="threshold"
                    type="select"
                    v-model="job.threshold"
                    :list="threshold"
                  />
                  <p class="font-italic text-muted">
                    {{ $t("shortcut_add_dropdown") }} <span><a href="#" @click.prevent="addDropdown(type='threshold' )">{{$t("add_threshold")}}</a></span>
                  </p>
                </div>
                <div class="col-sm-6">
                  <label for="framework">
                    {{ $t("framework") }}
                  </label>
                  <app-input
                    id="framework"
                    type="select"
                    v-model="job.framework"
                    :list="framework"
                  />
                  <p class="font-italic text-muted">
                    {{ $t("shortcut_add_dropdown") }} <span><a href="#" @click.prevent="addDropdown(type='framework' )">{{$t("add_frame_work")}}</a></span>
                  </p>
                </div>
              </div>
              <div class="form-group row" v-if="showEditor == true">
                <div class="col-sm-12">
                  <label for="inputs_editor">
                    {{ $t("description") }}
                  </label>
                  <app-input
                    type="text-editor"
                    :required="true"
                    id="text-editor-id"
                    :label="$t('message_placeholder')"
                    v-model="job.long_description"
                  />
                </div>
              </div>
              <div class="form-group row" v-if="showEditor == true">
                <div class="col-sm-12">
                  <label for="inputs_editor">
                    {{ $t("notes") }}
                  </label>
                  <app-input
                    type="text-editor"
                    :required="true"
                    id="notes"
                    :label="$t('message_placeholder')"
                    v-model="job.notes"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <app-input type="dropzone" v-model="dropzone_files" />
                    <small class="text-muted font-italic">
                      {{ $t("recommended_dropzone_file_validation") }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="mt-5 action-buttons" style="text-align: end">
                <app-load-more
                  :preloader="preloader"
                  :label="$t('submit')"
                  type="submit"
                  class-name="btn btn-primary mr-2 text-center"
                  @submit="updateJob"
                />
                <!-- <button
                  type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="updateJob"
                >
                  {{ $t("submit") }}
                </button> -->
                <button
                  type="submit"
                  class="btn btn-secondary"
                  @click.prevent="clear"
                >
                  {{ $t("clear") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <category-addmodal
      v-if="isAddModalActive"
      @close-modal="closeCategory"
    />
    <dropdown-addmodal
        v-if="isDropdownAddModalActive"
        :type="dropdownType"
        @close-modal="closeDropdown"
    />
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import {
  COMPANY_JOB_SHOW,
  COMPANY_JOB_UPDATE,
  CATEGORIES,
  DROPDOWN,
  COMPANY_JOB_EDIT,
} from "../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../../Helpers/AppLibrary";

export default {
  name: "FormGrid",
  extends: AppLibrary,
  mixins: [FormMixin],
  props: {
    id: Number,
    active: Object,
    refresh: Function,
    customerCompanyId: Number,
  },
  data() {
    return {
      showEditor: false,
      isDropdownAddModalActive: false,
      dropdownType: '',
      isAddModalActive: false,
      active: 1,
      isAddEditModalActive: false,
      preloader: false,
      dropzone_files: [],
      job: {},
      category: [],
      regionlist: [],
      threshold: [],
      framework: [],
      noticetypelist: [],
      bidRangeList: [],
      sites: {},
      truevalue: false,
      site_id: 0,
      task_id: 0,
      jobTypeList: [
        { id: "", value: "Choose One" },
        { id: "On-site", value: "On-site" },
        { id: "Hybrid", value: "Hybrid" },
        { id: "Remote", value: "Remote" },
      ],
      is_private: [
        { id: "", value: "Choose One" },
        { id: "0", value: "Public" },
        { id: "1", value: "Private" },
      ],
      status: [
        { id: "", value: "Choose One" },
        { id: "draft", value: "Draft" },
        { id: "active", value: "Active" },
        { id: "inprogress", value: "Inprogress" },
        { id: "completed", value: "Completed" },
      ],
    };
  },
  methods: {
    addDropdown(type) {
      this.dropdownType = type;
      this.isDropdownAddModalActive = true;
    },
    closeDropdown() {
      $("#dropdown-add-Modal").modal('hide');
      this.isDropdownAddModalActive = false;
      this.dropdownType = '';
      this.getDropdown();
    },
    addCategory() {
      this.isAddModalActive = true;
    },
    closeCategory() {
      $("#demo-add-edit-Modal").modal('hide');
      this.isAddModalActive = false;
      this.getCategories();
    },
    getSiteID(id) {
      this.site_id = id;
    },
    getSiteIDFromChild(id) {
      this.task_id = id;
      
    },
    setActiveIdFromChild(id) {
      this.active = id;
      
    },
    next(id) {
      if (this.active++ > 2) this.active = 1;
      this.site_id = id;
    },
    previous() {
      if (this.active-- < 2) this.active = this.active--;
    },
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {
        gender: "male",
      };
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
      this.fieldStatus = {
        isSubmit: false,
      };
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      this.isAddEditModalActive = false;
    },
    addNewSite() {
      this.addSite();
    },
    popSite(index) {
      this.site.splice(index, 1);
    },
    getJob(id) {
      axiosGet(COMPANY_JOB_EDIT + "/" + this.id)
        .then((res) => {
          this.job = res.data;
          this.job.noticetype = res.data.notice;
          this.job.notes = res.data.note.notes;
          this.sites = this.job.sites;
          this.truevalue = true;

          this.showEditor = true;
        })
        .catch((error) => {
          
        });
    },
    updateJob() {
      this.preloader = true;

      if (this.job.start_date)
        this.job.start_date = this.getDateFormatForBackend(this.job.start_date);
      if (this.job.end_date)
        this.job.end_date = this.getDateFormatForBackend(this.job.end_date);
        let formData = new FormData();
      if (this.dropzone_files.length) {
        this.dropzone_files.forEach((dropzone_file) => {
          formData.append(`dropzone_file[]`, dropzone_file);
        });
      }
      Object.keys(this.job).forEach((key) => {
        formData.append(key, this.job[key]);
      });
      let customerCompanyId = this.customerCompanyId;
      let url = COMPANY_JOB_UPDATE;
      if (customerCompanyId){
        url += '/' + customerCompanyId;
      }
      axiosPost(url, formData)
        .then((res) => {
          
          this.$toastr.s(res.data.message);
          this.job = {};
          // window.location = "/buyer/job";
          // this.active = 1;
          this.refresh(1);
        })
        .catch((error) => {
          
          this.$toastr.e(error.data.type);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    viewSite(id) {
      window.location = "site/" + id;
    },
    getCategories() {
      axiosGet(CATEGORIES)
        .then((res) => {
          this.category = res.data;
        })
        .catch((error) => {
          
        });
    },
    getDropdown() {
      axiosGet(DROPDOWN)
        .then((res) => {
          this.noticetypelist = res.data.notice ?? { id: "", value: "Choose One" };
          this.regionlist = res.data.region ?? { id: "", value: "Choose One" };
          this.threshold = res.data.threshold ?? { id: "", value: "Choose One" };
          this.framework = res.data.framework ?? { id: "", value: "Choose One" };
          this.bidRangeList = res.data.range ?? { id: "", value: "Choose One" };

        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    // let nsplit = split[6].split("?");
    // this.getJob(nsplit[0]);
    this.getJob();
    this.getCategories();
    this.getDropdown();
  },
};
</script>
